<app-header [class.collaspe]="isActive"></app-header>

<div class="main-container" [class.collaspe]="isActive">
  <div class="hamburger-nav" [style.top]="isSwitchUser ? '34px' : '21px'" (click)="hamburgerToggleDiv()"></div>
  <aside class="sidebar" [class.collaspe]="isActive">
    <app-sidebar></app-sidebar>
  </aside>
  

  <main class="rht-container" [class.collaspe]="isActive">
    <router-outlet></router-outlet>
  </main>
</div>

<!-- Crizac Assist: floating shell, present on every console page.
     Design and flow only - not connected to a model yet. -->
<app-crizac-assist></app-crizac-assist>
